import { toast } from 'react-toastify';

export const formatearJsonProductos = (productos) => {
    return productos.map((producto) => ({
        imagen: producto.images[0].src || null,
        nombre: producto.name || 'Nombre no disponible',
        url: producto.permalink || '/',
        descuento: Math.round(producto.discount_percentage * 100),
        precioOferta: producto.sale_price || '',
        precioRegular: producto.regular_price || '',
        precio: producto.price || '',
        calificacion: producto.calificacion || 0,
        on_sale: producto.on_sale,
        id: producto.id
    }));
};

export function toastSuccess(mensaje){
    toast.success(mensaje, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light"
    });
}
export function toastError(mensaje){
    toast.error(mensaje, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light"
    });
}
/*
export function toastWarning(mensaje){
    toast.warning(mensaje, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light"
    });
}
export function toastInfo(mensaje){
    toast.info(mensaje, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        icon: false
    });
}
export function toastWarningUnique(mensaje){

      toast.warning(mensaje, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        toastId: 1
    });  
}
export function toastErrorUniqueInfinite(mensaje){

    toast.error(mensaje, {
      position: "top-right",
      autoClose: false,
      hideProgressBar: false,
      closeOnClick: true, 
      draggable: true,
      progress: undefined,
      theme: "light",
      toastId: 1
  });  
}*/
export function handleError(error) {
    if (error && error.isAxiosError) {
        if (!error.response ) {
            return "Lo sentimos, pero ocurrió un problema inesperado en el servidor."
        }
        const status = error.response.status
        /*if (status === 404 ||status === 0 || status === 401 || status === 403) {
            return "Lo sentimos, pero ocurrió un problema inesperado en el servidor."
        }else */if( status === 400 ){
            if(error.response.data.message !== undefined)
                return error.response.data.message
            else if(error.response.data.msg !== undefined)
                return error.response.data.msg
            else
                return error.response.data
        }
        else
            return 'Lo sentimos, pero ocurrió un problema inesperado en el servidor.'
    }
}